import dataLayerPush from '../utils/dataLayerPush';
import accountLinkClickEvent from './accountLinkClick';
import addToCart from './addToCart';
import addToWishlist from './addToWishlist';
import { couponClick, couponView } from './coupon';
import selectItem from './selectItem';
import viewItem from './viewItem';
import search from './search';
import share from './share';
import shippingError from './shippingError';
import viewItemList from './viewItemList';
import virtualPageview from './virtualPageview';
import importTaxesInfoModalClose from './importTaxesInfoModalClose';
import calculateTaxes from './calculateTaxes';
import ShowCaseSelectContent from './showCaseSelectContent';
import summaryTechnicalSheet from './summaryTechnicalSheet';
import selectContent from './selectContent';
import selectPromotion from './selectPromotion';
import shipping from './shipping';
import viewPromotion from './viewPromotion';
import reviewFormSubmitModal from './reviewFormSubmitModal';
import { clickAttachImageEvent, clickAttachVideoEvent } from './reviewAttachMedia';
import { clickCondensedMediaImage, clickCondensedMediaVideo } from './reviewCondensedMedia';
import { orderEligibleListOnClick, orderEligibleListOnView, orderEligibleListOnViewItemList, orderNotEligibleOnView } from './orderEligibleList';
import { eventsFooter, paymentEventsFooter, certificatesEventsFooter } from './footerEvents';
import { quickClickSelectItem, quickClickViewItemList } from './quickClick';
import selectContentHeader from './selectContentHeader';
import viewContentHeader from './viewContentHeader';
import addToCartWarranty from './addToCartWarranty';
var events = {
  'account:link:click': [dataLayerPush(accountLinkClickEvent)],
  'addToCartWarranty:click': [dataLayerPush(addToCartWarranty)],
  'addToWishlist:click': [dataLayerPush(addToWishlist)],
  'coupon:selectItem': [dataLayerPush(couponClick)],
  'coupon:viewItem': [dataLayerPush(couponView)],
  'footer:certificate:click': [dataLayerPush(certificatesEventsFooter)],
  'footer:menu:click': [dataLayerPush(eventsFooter)],
  'footer:payment:click': [dataLayerPush(paymentEventsFooter)],
  'header:impression': [dataLayerPush(viewContentHeader)],
  'header:selectContent': [dataLayerPush(selectContentHeader)],
  'order-eligible-list:click': [dataLayerPush(orderEligibleListOnClick)],
  'order-eligible-list:impression': [dataLayerPush(orderEligibleListOnViewItemList)],
  'order-eligible-list:onview': [dataLayerPush(orderEligibleListOnView)],
  'order-not-eligible:impression': [dataLayerPush(orderNotEligibleOnView)],
  pageview: [dataLayerPush(search), dataLayerPush(virtualPageview)],
  'product:addToCart': [dataLayerPush(addToCart)],
  'product:calculateTaxes': [dataLayerPush(calculateTaxes)],
  'product:details': [dataLayerPush(viewItem)],
  'product:importTaxesClose:click': [dataLayerPush(importTaxesInfoModalClose)],
  'product:quickClickSelectItem': [dataLayerPush(quickClickSelectItem)],
  'product:quickClickViewItemList': [dataLayerPush(quickClickViewItemList)],
  'product:review:condensedMedia:image:click': [dataLayerPush(clickCondensedMediaImage)],
  'product:review:condensedMedia:video:click': [dataLayerPush(clickCondensedMediaVideo)],
  'product:reviewform:attachimage:click': [dataLayerPush(clickAttachImageEvent)],
  'product:reviewform:attachvideo:click': [dataLayerPush(clickAttachVideoEvent)],
  'product:reviewform:modal': [dataLayerPush(reviewFormSubmitModal)],
  'product:selectContent': [dataLayerPush(selectContent)],
  'product:selectPromotion': [dataLayerPush(selectPromotion)],
  'product:share': [dataLayerPush(share)],
  'product:shipping': [dataLayerPush(shipping)],
  'product:showcaseSelectContent': [dataLayerPush(ShowCaseSelectContent)],
  'product:summaryTechnicalSheet': [dataLayerPush(summaryTechnicalSheet)],
  'product:viewItemList': [dataLayerPush(viewItemList)],
  'product:viewPromotion': [dataLayerPush(viewPromotion)],
  'productlist:selectItem:click': [dataLayerPush(selectItem)],
  'shipping:response:error': [dataLayerPush(shippingError)]
};
export default events;